import { render } from "./BannedKeywords.vue?vue&type=template&id=d96ab36a"
import script from "./BannedKeywords.vue?vue&type=script&lang=js"
export * from "./BannedKeywords.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__